export default __webpack_public_path__ + "static/media/branding.a3d1cfe4.png";